/**
 * Three spacing maps exist deliberately, ported from these legacy files:
 * packages/ui/src/StructuredContentRenderer/components/Columns/constants.ts,
 * packages/ui/src/StructuredContentRenderer/components/Well/constants.ts, and
 * packages/ui/src/StructuredContentRenderer/components/Container/index.tsx. Well
 * uses smaller factors, and Container treats token '0' as unset where Columns
 * resolves it to zero.
 */
export type SpacingToken = 0 | 1 | 2 | 3 | 4 | 5 | '0' | '1' | '2' | '3' | '3-half' | '4' | '5';

export type WellSpacingToken =
  | SpacingToken
  | '0--wide'
  | '1--wide'
  | '2--wide'
  | '3--wide'
  | '3-half--wide'
  | '4--wide'
  | '5--wide';

// Columns/constants.ts factors resolve through spacing() to 0, 4, 8, 16, 24, 28, and 44px.
export const COLUMNS_SPACING_PX: Record<SpacingToken, number | undefined> = {
  '0': 0,
  '1': 4,
  '2': 8,
  '3': 16,
  '3-half': 24,
  '4': 28,
  '5': 44,
};

// Container/index.tsx factors resolve to the same pixels, except '0' is unset.
export const CONTAINER_SPACING_PX: Record<SpacingToken, number | undefined> = {
  '0': undefined,
  '1': 4,
  '2': 8,
  '3': 16,
  '3-half': 24,
  '4': 28,
  '5': 44,
};

// Well/constants.ts factors resolve to 4, 4, 8, 16, 28, and 44px; --wide is md only.
export const WELL_SPACING_PX: Record<WellSpacingToken, number | { md: number } | undefined> = {
  '0': undefined,
  '1': 4,
  '2': 4,
  '3': 8,
  '3-half': 16,
  '4': 28,
  '5': 44,
  '0--wide': undefined,
  '1--wide': { md: 4 },
  '2--wide': { md: 4 },
  '3--wide': { md: 8 },
  '3-half--wide': { md: 16 },
  '4--wide': { md: 28 },
  '5--wide': { md: 44 },
};
